import filterValidProps from "./filterValidProps.es.js";
import { mergeProps } from "./mergeProps.es.js";
const domProps = (props, ...styledExpressions) => {
  return filterValidProps(
    mergeProps(
      props,
      ...styledExpressions.map((r) => ({
        className: r.className
      }))
    )
  );
};
export {
  domProps
};
//# sourceMappingURL=domProps.es.js.map
